'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Caml_exceptions = require("bs-platform/lib/js/caml_exceptions.js");

var None = Caml_exceptions.create("System-Genetics.Baseline.None");

var Baseline = {
  None: None
};

function ExtendSystem(S) {
  var complementD = S.complementD;
  var complementR = S.complementR;
  var base_to_string = S.base_to_string;
  var toDNA = function (base) {
    return /* D */Block.__(0, [Curry._1(complementD, Curry._1(complementD, base))]);
  };
  var toRNA = function (base) {
    return /* R */Block.__(1, [Curry._1(complementR, Curry._1(complementR, base))]);
  };
  var replicate = function (param) {
    if (param.tag) {
      return /* R */Block.__(1, [Curry._1(complementR, param[0])]);
    } else {
      return /* D */Block.__(0, [Curry._1(complementD, param[0])]);
    }
  };
  var transcribe = function (param) {
    return /* R */Block.__(1, [Curry._1(complementR, param[0])]);
  };
  var reverse_transcribe = function (param) {
    return /* D */Block.__(0, [Curry._1(complementD, param[0])]);
  };
  var to_string = function (param) {
    return Curry._1(base_to_string, param[0]);
  };
  return {
          complementD: complementD,
          complementR: complementR,
          base_to_string: base_to_string,
          from_string: S.from_string,
          toDNA: toDNA,
          toRNA: toRNA,
          replicate: replicate,
          transcribe: transcribe,
          reverse_transcribe: reverse_transcribe,
          to_string: to_string
        };
}

var A = Caml_exceptions.create("A");

var T = Caml_exceptions.create("T");

var G = Caml_exceptions.create("G");

var C = Caml_exceptions.create("C");

var U = Caml_exceptions.create("U");

function complementD(param) {
  if (param === A) {
    return T;
  } else if (param === G) {
    return C;
  } else if (param === C) {
    return G;
  } else if (param === T || param === U) {
    return A;
  } else {
    return None;
  }
}

function complementR(base) {
  if (base === A) {
    return U;
  } else {
    return complementD(base);
  }
}

function base_to_string(param) {
  if (param === A) {
    return "A";
  } else if (param === T) {
    return "T";
  } else if (param === G) {
    return "G";
  } else if (param === C) {
    return "C";
  } else if (param === U) {
    return "U";
  } else {
    return "";
  }
}

function from_string(param) {
  switch (param) {
    case "A" :
        return Caml_option.some(A);
    case "C" :
        return Caml_option.some(C);
    case "G" :
        return Caml_option.some(G);
    case "T" :
        return Caml_option.some(T);
    case "U" :
        return Caml_option.some(U);
    default:
      return ;
  }
}

function toDNA(base) {
  return /* D */Block.__(0, [complementD(complementD(base))]);
}

function toRNA(base) {
  return /* R */Block.__(1, [complementR(complementR(base))]);
}

function replicate(param) {
  if (param.tag) {
    return /* R */Block.__(1, [complementR(param[0])]);
  } else {
    return /* D */Block.__(0, [complementD(param[0])]);
  }
}

function transcribe(param) {
  return /* R */Block.__(1, [complementR(param[0])]);
}

function reverse_transcribe(param) {
  return /* D */Block.__(0, [complementD(param[0])]);
}

function to_string(param) {
  return base_to_string(param[0]);
}

var Standard = {
  complementD: complementD,
  complementR: complementR,
  base_to_string: base_to_string,
  from_string: from_string,
  toDNA: toDNA,
  toRNA: toRNA,
  replicate: replicate,
  transcribe: transcribe,
  reverse_transcribe: reverse_transcribe,
  to_string: to_string
};

var S = Caml_exceptions.create("S");

var B = Caml_exceptions.create("B");

var P = Caml_exceptions.create("P");

var Z = Caml_exceptions.create("Z");

function complementD$1(base) {
  if (base === S) {
    return B;
  } else if (base === B) {
    return S;
  } else if (base === P) {
    return Z;
  } else if (base === Z) {
    return P;
  } else {
    return complementD(base);
  }
}

function base_to_string$1(base) {
  if (base === S) {
    return "S";
  } else if (base === B) {
    return "B";
  } else if (base === P) {
    return "P";
  } else if (base === Z) {
    return "Z";
  } else {
    return base_to_string(base);
  }
}

function from_string$1(base) {
  switch (base) {
    case "B" :
        return Caml_option.some(B);
    case "P" :
        return Caml_option.some(P);
    case "S" :
        return Caml_option.some(S);
    case "Z" :
        return Caml_option.some(Z);
    default:
      return from_string(base);
  }
}

function toDNA$1(base) {
  return /* D */Block.__(0, [complementD$1(complementD$1(base))]);
}

function toRNA$1(base) {
  return /* R */Block.__(1, [complementD$1(complementD$1(base))]);
}

function replicate$1(param) {
  if (param.tag) {
    return /* R */Block.__(1, [complementD$1(param[0])]);
  } else {
    return /* D */Block.__(0, [complementD$1(param[0])]);
  }
}

function transcribe$1(param) {
  return /* R */Block.__(1, [complementD$1(param[0])]);
}

function reverse_transcribe$1(param) {
  return /* D */Block.__(0, [complementD$1(param[0])]);
}

function to_string$1(param) {
  return base_to_string$1(param[0]);
}

var Hachimoji = {
  complementD: complementD$1,
  complementR: complementD$1,
  base_to_string: base_to_string$1,
  from_string: from_string$1,
  toDNA: toDNA$1,
  toRNA: toRNA$1,
  replicate: replicate$1,
  transcribe: transcribe$1,
  reverse_transcribe: reverse_transcribe$1,
  to_string: to_string$1
};

exports.Baseline = Baseline;
exports.ExtendSystem = ExtendSystem;
exports.Standard = Standard;
exports.Hachimoji = Hachimoji;
/* No side effect */
